export default function Page(){
    const slug = params.slug;
    console.log(params);
    return(
        <>
        </>
    )
}

